<template>
  <div :class="['mediacard-body', { reverse }]">
    <div class="text-body">
      <div class="text-wrapper">
        <div class="title">
          {{ title }}
        </div>
        <div class="sub-title-wrapper">
          <div class="sub-title">
            {{ subtitle }}
          </div>
          <a href="/wecobi-pitch-deck.pdf" target="_blank" class="button"
            >Explore</a
          >
        </div>
      </div>
    </div>
    <div class="image-wrapper">
      <img class="image" :src="imageSrc" :alt="title" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MediaCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.mediacard-body {
  width: 100%;
  height: 660px;
  background-color: #f7f7fa;
  border-radius: 20px;
  display: flex;
}
.text-body {
  width: 50%;
  height: 100%;
}
.text-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
}
.title {
  font-size: 30px;
  font-weight: 500;
  max-width: 540px;
  line-height: 1.1;
}
.sub-title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.sub-title {
  font-size: 16px;
  max-width: 540px;
}
.button {
  width: 156px;
  height: 50px;
  border: 2px solid black;
  border-radius: 30px;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  text-decoration: none;
}
.button:hover {
  color: #ffffff;
  border: 2px solid #ffffff;
  background-color: #000000;
}
.image-wrapper {
  width: 50%;
  height: 100%;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.reverse {
  flex-direction: row-reverse;
}

@media (max-width: 1280px) {
  .title,
  .sub-title {
    max-width: 440px;
  }
}

@media (max-width: 1024px) {
  .title,
  .sub-title {
    max-width: 308px;
  }
}
@media (max-width: 744px) {
  .title,
  .sub-title {
    max-width: 245px;
  }
  .sub-title {
    font-size: 14px;
  }
  .button {
    width: 97px;
    height: 40px;
    border: 2px solid black;
    font-size: 14px;
  }
}
@media (max-width: 588px) {
  .mediacard-body {
    display: flex;
    flex-direction: column-reverse;
    height: fit-content;
  }
  .text-body {
    width: 100%;
    height: 50%;
  }
  .text-wrapper {
    padding: 40px 50px;
    box-sizing: border-box;
    gap: 25px;
  }
  .image-wrapper {
    width: 100%;
    height: 50%;
  }
  .title,
  .sub-title {
    max-width: 455px;
  }
  .title {
    font-size: 25px;
  }
}
@media (max-width: 431px) {
  .text-wrapper {
    padding: 30px 20px;
  }
  .title,
  .sub-title {
    max-width: 100%;
    line-height: 1.2;
  }

  .sub-title {
    font-size: 12px;
  }
}
</style>
